'use strict';
var contentful = (function () {
    var cachedContentfulKeys = {};
    var renderer = new marked.Renderer();
    renderer.paragraph = function (text) {
        return text;
    };
    /**
     * @summary - Global object to hold parameters from web.config
     */
    var config = {
        authToken: "",
        spaceId: "",
        uri: ""
    };
    /**
     * @summary - Extracts the image asset from a Contentful array for the specified ID.
     * @param {array} array - The assets array included in a Contentful content model.
     * @param {string} id - The alphanumeric ID that represents an image asset.
     * @return {object} result
     */
    function extractImageAsset(array, id) {
        var result = {};
        for (var index = 0; index < array.length; index++) {
            if (array[index].sys.id === id) {
                result = array[index].fields;
                break;
            }
        }
        return result;
    }
    /**
     * @summary - Extracts the Contentful content model from the Contentful entry JSON object.
     * @param {object} json - A JSON object that represents Contentful entry.
     */
    function extractContentModel(json) {
        var entry = null;
        var assetArray = null;
        if (isNotNullOrUndefined(json) && isNotNullOrUndefined(json.items) &&
            json.items.length > 0 && isNotNullOrUndefined(json.items[0].fields)) {
            entry = json.items[0].fields;
        }
        if (isNotNullOrUndefined(json) && isNotNullOrUndefined(json.includes) &&
            isNotNullOrUndefined(json.includes.Asset)) {
            assetArray = json.includes.Asset;
        }
        if (entry !== null) {
            for (var prop in entry) {
                if (entry.hasOwnProperty(prop)) {
                    // Assuming that an object returned from Contentful is a link which contains an image URL
                    if (typeof entry[prop] === 'object') {
                        resolveLink(entry[prop], assetArray, prop);
                    }
                    else if (typeof entry[prop] === 'string') {
                        resolveText(entry[prop], prop);
                    }
                    else {
                        console.log('Contentful returned a type that we were not expecting: ' + entry[prop]);
                    }
                }
            }
        }
    }
    /**
     * Summary - Associates a visual element with a custom HTML attribute (ContentfulMS) and replaces it
     * Summary - This is with the assumption that a link returned from Contentful is an Image
     * @param {object} entry -  A JSON object returned from Contentful, derived from Fields
     * @param {object} assetArray - Assets object derived from the JSON object returned from Contentful
     * @param {string} tagName - Contentful ID element
     * @returns {void}
     */
    function resolveLink(entry, assetArray, tagName) {
        if (isNotNullOrUndefined(entry.sys) && isNotNullOrUndefined(entry.sys.linkType) &&
            entry.sys.linkType === 'Asset') {
            var imageAsset = extractImageAsset(assetArray, entry.sys.id);
            var contentfulName = $("[ContentfulMS='" + tagName + "']");
            contentfulName.each(function (index, obj) {
                //if the image is in a div, it is the Hero Image of the landing page
                if ($(obj).is('Div')) {
                    $(obj).attr('style', "background-image:url('https:" + imageAsset.file.url + "')");
                }
                else {
                    $(obj).attr('src', imageAsset.file.url);
                    if (imageAsset.title != '' && imageAsset.title != undefined) {
                        $(obj).attr('alt', imageAsset.title);
                    }
                }
            });
        }
    }
    /**
     * Summary - Associates a text element with a custom HTML attribute (ContentfulMS) and replaces it
     * @param {object} entry - Fields object derived from the JSON object returned from Contentful
     * @param {string} tagName - Contentful ID element
     * @returns {void}
     */
    function resolveText(entry, tagName) {
        var contentfulName = $("[ContentfulMS='" + tagName + "']");
        contentfulName.each(function (index, obj) {
            if ($(obj).is('input') || $(obj).is('textarea')) {
                $(obj).attr('placeholder', marked(entry, { renderer: renderer }));
            }
            else {
                $(obj).html(marked(entry, { renderer: renderer }));
            }
        });
    }
    /**
     * @summary - Retrieves the content model for the specified space and entry IDs from the Contentful Preview API.
     * @param {string} entryId - The ID of the Contentful space's entry.
     * @param {string} locale - The local used to load a specific brand.'
     */
    function injectContentInternal(entryId, locale) {
        var uri = buildUri(config.uri, config.authToken, config.spaceId, entryId, locale);
        if (!cachedContentfulKeys[entryId + locale]) {
            if (isNotNullOrUndefined(uri)) {
                $.ajax({
                    url: String.prototype.concat(uri),
                    data: { include: 1 },
                    type: 'GET',
                    dataType: 'json',
                    headers: { 'Authorization': 'Bearer ' + config.authToken },
                    async: false
                })
                    .done(function (json) {
                    replaceCurrentYearToken(json);
                    cachedContentfulKeys[entryId + locale] = json;
                    extractContentModel(json);
                })
                    .fail(function (xhr, status, errorThrown) {
                    console.log('Error:' + errorThrown);
                });
            }
        }
        else {
            extractContentModel(cachedContentfulKeys[entryId + locale]);
        }
    }
    function retrieveContentfulData(entryId, locale) {
        var uri = buildUri(config.uri, config.authToken, config.spaceId, entryId, locale);
        if (isNotNullOrUndefined(uri)) {
            $.ajax({
                url: String.prototype.concat(uri),
                data: { include: 1 },
                type: 'GET',
                dataType: 'json',
                headers: { 'Authorization': 'Bearer ' + config.authToken },
                async: false
            })
                .done(function (json) {
                cachedContentfulKeys[entryId + locale] = json;
            })
                .fail(function (xhr, status, errorThrown) {
                console.log('Error:' + errorThrown);
            });
        }
    }
    function getContentfulEntry(entryId, locale) {
        var entry = null;
        if (!cachedContentfulKeys[entryId + locale]) {
            retrieveContentfulData(entryId, locale);
            var json = cachedContentfulKeys[entryId + locale];
            if (isNotNullOrUndefined(json) && isNotNullOrUndefined(json.items) &&
                json.items.length > 0 && isNotNullOrUndefined(json.items[0].fields)) {
                entry = json.items[0].fields;
            }
        }
        else {
            var json = cachedContentfulKeys[entryId + locale];
            if (isNotNullOrUndefined(json) && isNotNullOrUndefined(json.items) &&
                json.items.length > 0 && isNotNullOrUndefined(json.items[0].fields)) {
                entry = json.items[0].fields;
            }
        }
        return entry;
    }
    /**
     * @summary - Helper method to check for Null or Undefined
     * @param {Object} variable - Element to be checked for Null or Undefined
     * @returns {boolean} isNotNullorUndefined
     */
    function isNotNullOrUndefined(variable) {
        if (variable !== null &&
            typeof variable !== 'undefined')
            return true;
        return false;
    }
    /**
     * @summary - Takes in multiple params and builds out a functional Contentful URI
     * @param {string} baseUri - Preview vs CDN (Draft vs Publish)
     * @param {string} authToken - Authorization token for Customer Portal Space
     * @param {string} spaceId - Space identification for Customer Portal Space
     * @param {string} entryId - Entry identification for Customer Portal landing page
     * @param {string} locale - Dynamic locale to handle multiple content models' localization
     * @returns {string} uri - Fully Formed URI
     */
    function buildUri(baseUri, authToken, spaceId, entryId, locale) {
        var uri = baseUri + "/spaces/" + spaceId + "/entries?sys.id=" + entryId + "&locale=" + locale;
        return uri;
    }
    /**
     * @summary - Takes in params as an object from Web.config and sets JavaScript global object
     * @param {Object} configObject - Object containing parameters passed from the web.config
     * @returns {void}
     */
    function configInternal(configObject) {
        config.authToken = configObject.AuthToken;
        config.spaceId = configObject.SpaceId;
        config.uri = configObject.Uri;
    }
    function replaceCurrentYearToken(contentfulJson) {
        if (contentfulJson && contentfulJson.items && contentfulJson.items.length > 0 && contentfulJson.items[0].fields && contentfulJson.items[0].fields.forProfitStatement) {
            var regex = /\{\{\s*currentYear\s*\}\}/i;
            contentfulJson.items[0].fields.forProfitStatement = contentfulJson.items[0].fields.forProfitStatement.replace(regex, new Date().getFullYear().toString());
        }
    }
    return {
        injectContent: injectContentInternal,
        config: configInternal,
        getContentfulEntry: getContentfulEntry
    };
}());
//# sourceMappingURL=contentful-integration.js.map